import React, { FC, PropsWithChildren } from 'react'
import { Flex } from '@moonpig/launchpad-components'
import { spacingPx, theme } from '@moonpig/launchpad-theme'
import { ProductModule } from '../types'

export const ListModule: FC<PropsWithChildren<ProductModule>> = ({
  children,
  ...props
}) => {
  if (!children) {
    return null
  }

  return (
    <Flex
      alignItems="start"
      flex={1}
      flexDirection="column"
      gap={spacingPx(6)({ theme })}
      {...props}
    >
      {children}
    </Flex>
  )
}
